// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__c7aTv","info":"UpdateTermsInfo_info__1ouG_"};